import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { canActivateAuthRole } from './auth/auth-guard';
import { Role } from 'shared-lib';

export const routes: Routes = [
  {
    path: '', component: HomeComponent
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OrganizationAdmin, Role.Administrator, Role.OrganizationMember] }
  },
  {
    path: 'pools',
    loadComponent: () => import('./pools/pool-list/pool-list.component').then(m => m.PoolListComponent),
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OrganizationAdmin, Role.Administrator] }
  },
  {
    path: 'pools/:configId',
    loadComponent: () => import('./pools/pool-detail/pool-detail.component').then(m => m.PoolDetailComponent),
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OrganizationAdmin, Role.Administrator] }
  },
  {
    path: 'pools/:configId/transactions',
    loadComponent: () => import('./pools/pool-transactions/pool-transactions.component').then(m => m.PoolTransactionsComponent),
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OrganizationAdmin, Role.Administrator] }
  },
  {
    // Easypass self-service is open to OrganizationMember as well as OrganizationAdmin,
    // matching the backend: the organization-app controller admits OrganizationMember and
    // narrows only the endpoints that administer the organization. Revoking an Easypass
    // (DELETE) stays admin-only there, so the list/detail pages must hide that action for
    // a member rather than let it 403 after the click.
    path: 'easypasses',
    loadComponent: () => import('./easypass/easypass-list/easypass-list.component').then(m => m.EasypassListComponent),
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OrganizationAdmin, Role.Administrator, Role.OrganizationMember] }
  },
  {
    path: 'easypasses/:easypassId',
    loadComponent: () => import('./easypass/easypass-detail/easypass-detail.component').then(m => m.EasypassDetailComponent),
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OrganizationAdmin, Role.Administrator, Role.OrganizationMember] }
  },
  {
    // Managing people is an organization-administration job, matching the backend: the employee,
    // license-plate and pool endpoints all carry OrgAdminOnly, so a member reaching this page would
    // only meet a 403 on the first request.
    path: 'members',
    loadComponent: () => import('./members/member-list/member-list.component').then(m => m.MemberListComponent),
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OrganizationAdmin, Role.Administrator] }
  },
  {
    path: 'members/:parkerId',
    loadComponent: () => import('./members/member-detail/member-detail.component').then(m => m.MemberDetailComponent),
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OrganizationAdmin, Role.Administrator] }
  },
  {
    path: 'my-account',
    loadComponent: () => import('./my-account/my-account.component').then(m => m.MyAccountComponent),
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OrganizationAdmin, Role.Administrator, Role.OrganizationMember] }
  },
  { path: '**', redirectTo: 'home' }
];
